/**
 * Maps route paths to entity types for custom fields
 */
export const getEntityTypeFromRoute = (routePath: string): string | null => {
  const routeMap: Record<string, string> = {
    '/clients': 'Client',
    '/client-contacts': 'ClientContact',
    '/tasks': 'Task',
    '/crm-tasks': 'Task',
    '/support-tickets': 'Ticket',
    '/tickets': 'Ticket',
    '/leads': 'Lead',
    '/todos': 'Todo',
    '/notes': 'Note',
    '/crm-notes': 'Note',
    '/invoices': 'Invoice',
    '/client-invoices': 'Invoice',
    '/suppliers': 'Supplier',
    '/supplier-invoices': 'SupplierInvoice',
    '/supplier-invoice-payments': 'SupplierInvoicePayment',
    '/conversations': 'Conversation',
    '/projects': 'Project',
    '/packages': 'Package',
    '/support-agreements': 'SupportAgreement',
    '/expenses': 'Expense',
    '/payables': 'Payable',
    '/offers': 'Offer',
    '/catalog-items': 'CatalogItem',
    '/recurring-payables': 'RecurringPayable',
    '/calls': 'Call',
    '/appointments': 'Appointment',
    '/reminders': 'Reminder',
  };

  // Check exact matches first
  if (routeMap[routePath]) {
    return routeMap[routePath];
  }

  // Check if route path contains any of the keys
  for (const [key, entityType] of Object.entries(routeMap)) {
    if (routePath.includes(key.replace('/', ''))) {
      return entityType;
    }
  }

  return null;
};

/**
 * Maps module title to entity type
 */
export const getEntityTypeFromTitle = (title: string): string | null => {
  const titleMap: Record<string, string> = {
    'Clients': 'Client',
    'Client Contacts': 'ClientContact',
    'Tasks': 'Task',
    'Support Tickets': 'Ticket',
    'Tickets': 'Ticket',
    'Leads': 'Lead',
    'Todos': 'Todo',
    'Notes': 'Note',
    'Invoices': 'Invoice',
    'Suppliers': 'Supplier',
    'Supplier Invoices': 'SupplierInvoice',
    'Supplier Invoice Payments': 'SupplierInvoicePayment',
    'Conversations': 'Conversation',
    'Projects': 'Project',
    'Packages': 'Package',
    'Support Agreements': 'SupportAgreement',
    'Expenses': 'Expense',
    'Calls': 'Call',
    'Appointments': 'Appointment',
    'Reminders': 'Reminder',
  };

  return titleMap[title] || null;
};
